module.exports = __webpack_public_path__ + "static/S-Motion-logo-984a6a6f1d17981c9ecbbee353496b7c.jpg";